/**
 * Created by kongwm.kong on 2017/7/19.
 *
 * 自定义验证规则
 */
import { Validator } from 'vee-validate';
import $http from '../util/http';
import axios from 'axios';
//手机号码
Validator.extend('mobile', {
    messages: {
        zh_CN : field => '手机号码输入不正确'
    },
    validate: value => {
        return value.length == 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)
    }
});

//注册密码
Validator.extend('password', {
    messages: {
        zh_CN : field => '请输入6-20位数字+字母组合密码'
    },
    validate: value => {
        return  /^[0-9a-zA-Z]{6,20}$/.test(value)
    }
});
/*判断两次密码是否一致*/
Validator.extend('equalPassword', {
    messages: {
        zh_CN : field => '两次密码输入不一致'
    },
    validate: value => {
            return value === '1';
    }
});

/*判断会员名*/
Validator.extend('asyncVipName', {
    messages: {
        zh_CN : field => '会员名已存在'
    },
    validate: value => {
        // setTimeout(()=>{
        return axios.get(`/account/register/checkByUserName?userName=${value}`).then(response => {
                let flag = false;
                if(response.data.code === 200){
                    flag = response.data.data;
                }else {
                    flag = false;
                }
                return {
                    valid: flag
                }
            }).catch(error=> { return {valid: false} })
            // return false
        // }, 1000);
    }
});


/*判断会员名*/
Validator.extend('number', {
    messages: {
        zh_CN : field => '请输入纯数字'
    },
    validate: value => {
        return /^\d+$/.test(value);
    }
});

/*asyncMobile*/
Validator.extend('asyncMobile', {
    messages: {
        zh_CN : field => '手机号码已存在'
    },
    validate: value => {
        return axios.get(`/account/register/checkByPhone?phone=${value}`).then(response => {
            let flag = false;
            if(response.data.code === 200){
                flag = response.data.data;
            }else {
                flag = false;
            }
            return {
                valid: flag
            }
        }).catch(error=> { return {valid: false} })
    }
});

/*判断会员名*/
Validator.extend('onlyImage', {
    messages: {
        zh_CN : field => '格式支持jpeg、jpg、png'
    },
    validate: value => {
        if(value.length){
            return /\.(jpg|jpeg|png|JPEG|JPG|PNG)$/.test(value[0].name);
        } else {
            return false;
        }
    }
});
/*公司英文名称englishName*/
Validator.extend('englishName', {
    messages: {
        zh_CN : field => '格式支持大小写英文以及数字'
    },
    validate: value => {
            return /^([0-9a-zA-Z\s\(\)]|\.){0,100}$/.test(value);
        }
});
/*登记编号privateRegNum*/
Validator.extend('privateRegNum', {
    messages: {
        zh_CN : field => '该编号不符合通用规则，建议修改'
    },
    validate: value => {
        return /^[a-zA-Z][0-9]{7}$/.test(value);
    }
});
/*备案号privateRegNum*/
Validator.extend('asyncRegNum', {
    messages: {
        zh_CN : field => '该备案号已有公司使用，请勿重复录入'
    },
    validate: value => {
        return axios.get(`/product/checkRegisterNumber?registerNumber=${value}`).then(response => {
            let flag = false;
            if(response.data.code === 200){
                flag = response.data.data;
            }else {
                flag = false;
            }
            return {
                valid: flag
            }
        }).catch(error=> { return {valid: false} })
    }
});
/*净值格式netValid*/
Validator.extend('netValid', {
    messages: {
        zh_CN : field => '请输入净值，如：1.2343'
    },
    validate: value => {
        return /^[0-9]+\.[0-9]{4}$/.test(value);
    }
});
/*备案号码registerNumber*/
Validator.extend('alphaNumber', {
    messages: {
        zh_CN : field => '支持字母(大小写)数字,不超过10位'
    },
    validate: value => {
        return /^([0-9a-zA-Z]){0,10}$/.test(value);
    }
});

/*保持两位小数twoPoint*/
Validator.extend('twoPoint', {
    messages: {
        zh_CN : field => '小数点后两位，格式如：100.00'
    },
    validate: value => {
        return /^(-)?[0-9]+\.[0-9]{2}$/.test(value);
    }
});

/*forthPoint*/
Validator.extend('fourthPoint', {
    messages: {
        zh_CN : field => '小数点后四位，格式如：1.0000'
    },
    validate: value => {
        return /^(-)?[0-9]+\.[0-9]{4}$/.test(value);
    }
});

export default Validator;



// WEBPACK FOOTER //
// ./src/config/customValidate.js